export default {
  newWorkOrder: state => state.newWorkOrder,
  workOrder: state => state.workOrder,
  workOrders: state => state.workOrders,
  viewDashboard: state => state.viewDashboard,
  viewSection: state => state.viewSection,
  status: state => state.status,
  pageSize: state => state.pageSize,
  searchTerm: state => state.searchTerm,
  retrospectiveDay: state => state.retrospectiveDay,
  tools: state => state.tools,
  devices: state => state.devices,
  protocols: state => state.protocols,
  interfaces: state => state.interfaces,
  statuses: state => state.statuses,
  scanTypes: state => state.scanTypes,
  dtcs: state => state.dtcs,
  odometerUnits: state => state.odometerUnits,
  insurances: state => state.insurances,
  timeZones: state => state.timeZones,
  years: state => state.years,
  contacts: state => state.contacts,
  reviewScans: state => state.reviewScans,
  damagePositions: state => state.damagePositions,
  apiUrl: state => state.apiUrl,
  businessInfo: state => state.businessInfo,
  repairLines: state => state.repairLines,
  workOrderHistory: state => state.workOrderHistory,
  filterOptions: state => state.filterOptions,
  stateDefaults: state => state.stateDefaults,
  stateAssemblyOptions: state => state.stateAssemblyOptions,
  stateSrsOptions: state => state.stateSrsOptions,
  stateLightOptions: state => state.stateLightOptions,
  stateKeyEngineOptions: state => state.stateKeyEngineOptions,
  stateDamageLevelOptions: state => state.stateDamageLevelOptions,
  stateDamagePositionOptions: state => state.stateDamagePositionOptions,
  workOrderNotes: state => state.workOrderNotes,
  filterBy: state => state.filterBy,
  sortDir: state => state.sortDir,
  orderBy: state => state.orderBy,
  hubData: state => state.hubData,
  dispatchWorkOrders: state => state.dispatchWorkOrders,
  mobileHandoff: state => state.mobileHandoff,
  helprequests: state => state.helprequests,
  deviceStatisticInterval: state => state.deviceStatisticInterval,
  lineCount: state => state.lineCount,
  isTeamOnly: state => state.isTeamOnly,
  isCompletedOnly: state => state.isCompletedOnly,
  shopDevice: state => state.shopDevice
}



// WEBPACK FOOTER //
// ./src/store/modules/work-orders/getters.js